import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "register-card" }
const _hoisted_3 = { class: "register-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "48",
          color: "red-darken-1",
          class: "mb-3"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("mdi-account-plus", -1)
          ]))]),
          _: 1
        }),
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "register-title" }, "Înregistrare Portal HR", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "register-subtitle" }, "Creați cont de self-service angajat", -1))
      ]),
      _createVNode(_component_v_stepper, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.step) = $event)),
        items: ['Selectare companie', 'Date cont'],
        flat: ""
      }, {
        "item.1": _withCtx(() => [
          _createVNode(_component_v_card, { flat: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: _ctx.form.companyID,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.companyID) = $event)),
                    items: _ctx.companies,
                    "item-title": "Name",
                    "item-value": "ID",
                    label: "Companie",
                    "prepend-inner-icon": "mdi-domain",
                    variant: "outlined",
                    density: "comfortable",
                    loading: _ctx.loadingCompanies,
                    "no-data-text": "Nu există companii disponibile"
                  }, null, 8, ["modelValue", "items", "loading"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login'))),
                    variant: "text"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("Înapoi la login", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "red-darken-1",
                    disabled: !_ctx.form.companyID,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 2))
                  }, {
                    default: _withCtx(() => [
                      _cache[17] || (_cache[17] = _createTextVNode(" Continuă ", -1)),
                      _createVNode(_component_v_icon, { class: "ml-1" }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("mdi-arrow-right", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        "item.2": _withCtx(() => [
          _createVNode(_component_v_card, { flat: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.formValid,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formValid) = $event)),
                    ref: "registerForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
                        label: "Email de serviciu",
                        "prepend-inner-icon": "mdi-email",
                        variant: "outlined",
                        density: "comfortable",
                        class: "mb-3",
                        rules: [_ctx.required, _ctx.emailRule],
                        type: "email"
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.form.internalCode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.internalCode) = $event)),
                        label: "Marcă (InternalCode)",
                        "prepend-inner-icon": "mdi-badge-account",
                        variant: "outlined",
                        density: "comfortable",
                        class: "mb-3",
                        rules: [_ctx.required],
                        hint: "Marca angajatului din sistemul HR",
                        "persistent-hint": ""
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.form.password,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.password) = $event)),
                        label: "Parolă",
                        "prepend-inner-icon": "mdi-lock",
                        "append-inner-icon": _ctx.showPass ? 'mdi-eye-off' : 'mdi-eye',
                        "onClick:appendInner": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPass = !_ctx.showPass)),
                        type: _ctx.showPass ? 'text' : 'password',
                        variant: "outlined",
                        density: "comfortable",
                        class: "mb-3",
                        rules: [_ctx.required, _ctx.minLength]
                      }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.form.confirmPassword,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                        label: "Confirmare parolă",
                        "prepend-inner-icon": "mdi-lock-check",
                        type: _ctx.showPass ? 'text' : 'password',
                        variant: "outlined",
                        density: "comfortable",
                        rules: [_ctx.required, _ctx.passwordMatch]
                      }, null, 8, ["modelValue", "type", "rules"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.errorMsg)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "error",
                        class: "mt-3",
                        variant: "tonal",
                        closable: "",
                        "onClick:close": _cache[9] || (_cache[9] = ($event: any) => (_ctx.errorMsg = ''))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorMsg), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-space-between pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.step = 1)),
                    variant: "text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-1" }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("mdi-arrow-left", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[19] || (_cache[19] = _createTextVNode(" Înapoi ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "red-darken-1",
                    loading: _ctx.loading,
                    disabled: !_ctx.formValid,
                    onClick: _ctx.register
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-1" }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("mdi-account-check", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[21] || (_cache[21] = _createTextVNode(" Creează cont ", -1))
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}